import {
  Dispatch,
  useState
} from 'react';
import {
  SupportTicketController
} from '../../../../api/support/support-ticket.controller';
import {useAsyncEffect} from '../../../../hook/use-initial-load';
import {SupportTicketAttachmentModel} from '../../../../model/support/support-ticket-attachment.model';
import {Searchable} from '../../../../state/searchable-state';

export namespace SupportPageHooks {
  import QuerySupportTicketsRes = SupportTicketController.QuerySupportTicketsRes;

  export const useSupportTickets = (searchable: Searchable): [QuerySupportTicketsRes | null, Dispatch<QuerySupportTicketsRes>] => {
    const [supportTickets, setSupportTickets] = useState<QuerySupportTicketsRes | null>(null);
    useAsyncEffect(async () => {
      setSupportTickets(await fetchSupportTickets(searchable))
    }, [searchable.filters, searchable.groupedFilters, searchable.fullTextSearch, searchable.page, searchable.pageSize, searchable.ordering]);
    return [supportTickets, setSupportTickets];
  }

  export const fetchSupportTickets = async (searchable: Searchable): Promise<QuerySupportTicketsRes> =>
    (await SupportTicketController.querySupportTickets(searchable))


  export const useSupportTicketAttachments = (ticketId: string): [SupportTicketAttachmentModel[], Dispatch<SupportTicketAttachmentModel[]>] => {
    const [supportTicketAttachments, setSupportTicketAttachments] = useState<SupportTicketAttachmentModel[]>([]);
    useAsyncEffect(async () => {
      setSupportTicketAttachments(await fetchSupportTicketAttachments(ticketId))
    }, []);
    return [supportTicketAttachments, setSupportTicketAttachments];
  }

  export const fetchSupportTicketAttachments = async (ticketId: string): Promise<SupportTicketAttachmentModel[]> =>
    (await SupportTicketController.querySupportTicketAttachments(ticketId))


}